<template>
  <div v-loading.absolute="isLoading" class="side-stock-trade">
    <div class="head">
      <span class="title" :title="title">{{ title }}</span>
      <icon name="cross" @click.native="closeTradeRequest" />
    </div>
    <div class="main">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from 'com/Icon'
import formatOrderRequestToLocalParams from 'store/utils/formatOrderRequestToLocalParams'

export default {
  name: 'TradePanel',
  components: { Icon },
  props: {
    title: String
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['isIb', 'activeStock', 'curAccountId', 'tradeRequest']),
    symbol() {
      return this.activeStock.webLocal
        ? this.activeStock.webLocal.symbol
        : this.activeStock.symbol
    }
  },
  watch: {
    curAccountId() {
      this.closeTradeRequest()
    },
    symbol() {
      this.closeTradeRequest()
    }
  },
  mounted() {
    this.initTradeRequest()
  },
  methods: {
    initTradeRequest() {
      this.isLoading = true
      const tradeRequest = { ...this.tradeRequest }
      const promises = [this.$store.dispatch('getUserAssets')]
      if (!this.tradeRequest.contract) {
        promises.push(
          this.$store
            .dispatch('getStockContract', tradeRequest.stock)
            .then(contract => {
              tradeRequest.contract = contract
            })
        )
      }
      if (!this.tradeRequest.isModify) {
        promises.push(
          this.$store.dispatch('getNewIbTradeOrderId').then(orderId => {
            tradeRequest.orderId = orderId
          })
        )
      }
      Promise.all(promises)
        .then(() => {
          this.$store.dispatch(
            'newTradeRequest',
            formatOrderRequestToLocalParams(tradeRequest)
          )
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeTradeRequest() {
      this.$store.dispatch('removeTradeRequest')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~uikit';
.side-stock-trade {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 5px;
  bottom: 43px;
  z-index: 1000; // 需要覆盖side-stock-view交易侧边栏
  width: 320px;
  right: 0;
  background-color: var(--bg-block);
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-bottom: 1px solid var(--special-color);
    box-sizing: border-box;
    font-size: 14px;

    span {
      max-width: 250px;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    svg {
      display: block;
      color: @grey;
      cursor: pointer;
      &:hover {
        color: var(--active-color);
      }
    }
  }
  .main {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
